module.exports = __webpack_public_path__ + "assets/media/medal-about.fe499c39.svg";